export default class ArrayHelpers {
  static removeItem<T>(arr: Array<T>, value: T): Array<T> {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  static removeItems<T>(array: Array<T>, valuesToRemove: Array<T>): Array<T> {
    valuesToRemove.forEach(el => this.removeItem(array, el));
    return array;
  }
 
}
